import { render, staticRenderFns } from "./OtherLabourListView.vue?vue&type=template&id=9573aef8"
import script from "./OtherLabourListView.vue?vue&type=script&lang=js"
export * from "./OtherLabourListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports